import React from 'react';
import { object } from 'prop-types';
import get from 'lodash/get';

import {
  SCAlertBox,
  Header,
  Text,
  AdminImage,
  RejectBox,
  TextBox,
} from './styles';

AlertBox.propTypes = {
  approvalStatus: object.isRequired, // eslint-disable-line react/forbid-prop-types
};

function AlertBox({ approvalStatus }) {
  return (
    <SCAlertBox>
      <RejectBox key={approvalStatus.date}>
        <AdminImage
          alt="adminImage"
          src={get(approvalStatus, 'approvalStatus.admin.picture')}
        />
        <TextBox key={approvalStatus.date}>
          <Header>
            {' '}
            {get(approvalStatus, 'admin.name')} har nekat med meddelandet:
          </Header>{' '}
          {/* eslint-disable-line react/no-unescaped-entities */}
          <Text>{approvalStatus.message}</Text>
        </TextBox>
      </RejectBox>
    </SCAlertBox>
  );
}

export default AlertBox;



// WEBPACK FOOTER //
// ./src/components/AlertBoxForm/AlertBoxForm.js